import * as CONSTANTS from '../modules/constants';
import { SvgSprite } from '../modules/svg-loader';
import { stickyHeader } from '../modules/sticky-header';
import { MobileNav } from '../modules/mobile-navigation';
import { MobileDropDownNav } from '../modules/mobile-drop-down-navigation';
import { ImageVideoList } from '../modules/imagevideolist';
import { Gallery } from '../modules/gallery';
import { nodeListToArray } from '../helpers/nodeListToArray';
import { Accordion } from '../modules/accordion';
import 'objectfitPolyfill';
import * as smoothscroll from 'smoothscroll-polyfill';
import { footer } from '../modules/footer';
import { displayScrollToTop } from '../modules/scroll-to-top';
import { scrollToTop } from '../modules/scroll-to-top';
import { alertMessage } from '../modules/alert';
import wrapImages from '../modules/wrap-images';
import { Modal } from '../modules/modal';
import { VideoModal } from '../modules/videoModal';
import { convertPhoneNumbersToLinks } from '../helpers/telephone-linker';
import { mobileNavigationToggles } from '../modules/mobile-navigation-toggles';
import HosptialLocationsMap from '../modules/hospitalLocationsMap';
import { ExternalLinksA11yEnhancements } from '../modules/externallinksa11yenhancements';
import { FullBleedImage } from '../modules/fullBleedImagesIE';

(() => {
    // Accordion Init
    // Use adage-data-accordion-list to allow all accordion items to be open at once
    // Use data-accordion-list if you want to restrict open accordion items to one
    let accordionsMultipleOpen = new Accordion({
        oneOpenAtATime: false,
        accordionTarget: '[adage-data-accordion-list]'
    });

    let accordions = new Accordion({
        oneOpenAtATime: true,
        accordionTarget: '[data-accordion-list]'
    });

    // Fix images in IE that must be full-bleed
    let fullBleedImages = nodeListToArray(document.querySelectorAll('[data-full-bleed-image] img'));
    fullBleedImages.forEach(imageEl => {
        new FullBleedImage(imageEl);
    });

    // Instantiate modals without videos
    let modals = nodeListToArray(document.querySelectorAll('[data-modal-no-video]'));
    modals.forEach(modal => {
        new Modal(modal);
    });

    // Instantiate global modals without videos
    let globalModals = nodeListToArray(document.querySelectorAll('[data-modal-global]'));
    globalModals.forEach(modal => {
        new Modal(modal, null, true);
    });

    // Instantiate Video Modals from Starter-kit
    let videoModals = nodeListToArray(document.querySelectorAll('[data-modal]'));
    videoModals.forEach(modal => {
        new VideoModal(modal);
    });

    // Gallery Init
    // Note: it is recommended to use loop: false when creating a gallery with videos at the beginning/end because of duplicated slides.
    let galleryClass = 'carousel';

    // Home page gallery has its own constructor
    // Because we need to pass additional parameters to the constructor
    let homeGallery = document.querySelector('[adage-data-home-gallery]');

    if (homeGallery) {
        let autoRotate = homeGallery.getAttribute('data-auto-rotate');
        let autoRotateDelay = homeGallery.getAttribute('data-auto-rotate-delay');
        let autoRotateDelayInt = parseInt(autoRotateDelay, 10);
        let autoRotateSpeed = homeGallery.getAttribute('data-auto-rotate-transition-speed');
        let autoRotateSpeedInt = parseInt(autoRotateSpeed, 10);

        if (autoRotateDelayInt <= 0) {
            autoRotateDelayInt = 5000; // Delay is in milliseconds
        }

        if (autoRotateSpeedInt <= 0) {
            autoRotateSpeedInt = 1500; // Transition speed is in milliseconds
        }

        homeGallery.classList.add(`${galleryClass}-home`);

        new Gallery({
            containerClass: `${galleryClass}-home`,
            slidesPerView: 'auto',
            spaceBetween: 24,
            speed: autoRotate === 'True' ? autoRotateSpeedInt : 300,
            autoplay:
                autoRotate === 'True'
                    ? {
                          delay: autoRotateDelayInt,
                          disableOnInteraction: false
                      }
                    : false,
            breakpoints: {
                640: {
                    spaceBetween: 16
                }
            }
        });
    }

    let galleries = nodeListToArray(document.querySelectorAll('[adage-data-gallery]'));

    galleries.forEach((gallery, index) => {
        gallery.classList.add(`${galleryClass}-${index}`);
        new Gallery({
            containerClass: `${galleryClass}-${index}`,
            slidesPerView: 'auto',
            spaceBetween: 24,
            breakpoints: {
                640: {
                    spaceBetween: 16
                }
            }
        });
    });

    // Starter-kit Gallery Init
    // Note: it is recommended to use loop: false when creating a gallery with videos at the beginning/end because of duplicated slides.
    let starterkitGalleryClass = 'single-item-gallery';
    let starterkitGalleries = nodeListToArray(document.querySelectorAll('[data-gallery]'));

    starterkitGalleries.forEach((gallery, index) => {
        gallery.classList.add(`${starterkitGalleryClass}-${index}`);
        new Gallery({
            containerClass: `${starterkitGalleryClass}-${index}`,
            slidesPerView: 1
        });
    });

    // Request SVG sprite
    let spritePath = (window as any).SVG_SPRITE_PATH || '/Static/img/svg-sprite.svg';
    new SvgSprite(spritePath);
    new SvgSprite('/Static-Adage/img/adage-sprite.svg');

    // Sticker Header
    stickyHeader();

    // Mobile Navigation
    new MobileNav();

    new MobileDropDownNav();

    let mobileNavElement = null;
    if (CONSTANTS.MOBILE_NAV) {
        mobileNavElement = new mobileNavigationToggles(CONSTANTS.MOBILE_NAV as HTMLElement);
    }

    new ImageVideoList();

    // Smooth scroll polyfill
    smoothscroll.polyfill();

    // Footer a11y logic
    footer();

    // Scroll to Top logic
    displayScrollToTop();
    scrollToTop();

    // Alert Message
    alertMessage();

    // Wraps img elements found in WYSIWYG content with
    // a span we're using for design purposes
    wrapImages();

    // Converts phone numbers in WYSIWYG to phone links
    convertPhoneNumbersToLinks();

    // Generates map for hospital locations map block
    HosptialLocationsMap();

    // Add screen reader text and icon to external links
    new ExternalLinksA11yEnhancements();
})();
